<template>
        <div class='small-12 medium-12 large-12 hd-12 columns content'>
            <dean-notification></dean-notification>
            <div class="row fields">
                    <slot name="left"></slot>
                    <slot name="center"></slot>
                    <slot name="right"></slot>
            </div>
        </div>
</template>

<script lang="ts">
    // VUE
    import {
        Vue,
        Component,
        Prop,
    } from 'vue-property-decorator';

    import {
        deanFormRow,
        deanSectionTitle,
        messageIcon,
    } from '@deanone/dean-components';

    import deanInputSelect from '@/components/deanComponents/deanInputSelect.vue';
    import DeanNotification from '@/components/deanComponents/deanNotification.vue';

    @Component({
        components: {
            DeanNotification,
            deanInputSelect,
            deanFormRow,
            deanSectionTitle,
            messageIcon,
        },
    })
    export default class DeanThreeColumnLayout extends Vue {
        public messageIcon: object = messageIcon;

        // Properties
        @Prop({ default: '' }) private title!: string;
    }
</script>

<style lang='scss' scoped>
    @import '~@deanone/dean-components/src/scss/vars';

    .row.fields {
        display: grid;
        grid-template-columns: 20% 40% 40%;
    }
    @media #{$medium-down} {
        .row.fields {
            grid-template-columns: 100%;
        }
    }
</style>
